import { Component, OnInit, OnChanges, OnDestroy, SimpleChanges, ViewChild, ElementRef, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable,forkJoin } from 'rxjs';

declare var H: any;

@Component({
    selector: 'app-here-map',
    templateUrl: './here-map.component.html',
    styleUrls: ['./here-map.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HereMapComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

    @ViewChild('map', { static: true })
    public mapElement: ElementRef;

    @Input()
    public appId: any;

    @Input()
    public appCode: any;

    @Input()
    public start: { lat: number, lng: number };

    @Input()
    public finish: { lat: number, lng: number };

    @Input() currentTruckLocation: {
        lat: number;
        lng: number;
        updatedAt?: string;
    };
    @Input() startLabelData: any;
    @Input() endLabelData: any;
    // @Input()
    // public startLoc: any;

    // @Input()
    // public endLoc: any;

    @Input()
    public width: any;

    @Input()
    public height: any;

    @Input()
    public searchByQuery:string;
    @Input()
    public mapOptions:any;
    @Input()
    public ConfigData:{apikey: string};

    public directions: any;

    private platform: any;
    private map: any;
    private router: any;
    private ui: any;
    private routeLine: any;
    public isMapAvailabel = true;
    private defaultUSALatAndLng = { lat: 39.651184, lng: -102.315836 };
    private truckMarker: any;
    public constructor() { }

    public geocode(platform, query){
        var platform1 = new H.service.Platform({
            apikey: this.ConfigData.apikey || "iPmN1dmOW73s89ukJgvhfCMG8Y-AZyZlF5L48Q1rJ9o"
        });
        // q: [  '85601 USA', "89104 USA"],
        // q: [  "Alaska USA"], // which giving 20 records
        // qq:
        return new Observable(observer => {
            var geocoder = platform.getSearchService(),
                geocodingParameters;

                if (query.includes('=')) {
                    geocodingParameters = { qq: query };
                } else {
                    geocodingParameters = { q: query };
                }


            geocoder.geocode(
                geocodingParameters,
                (result) => {
                    if(result && result.items && result.items.length){
                        observer.next(result.items[0]);
                        observer.complete();
                    }else {
                        observer.error("No record")
                        observer.complete();
                    }
                },
                (err) => {
                    observer.error(err);
                    observer.complete();
                }
            );
        });
    }

    public onSuccess(result) {
        var locations = result.items;
        if(locations && locations.length){
            this.start.lat = locations[0].position.lat;
            this.start.lng = locations[0].position.lng;
        }
        if(locations && locations[1]){
            this.finish.lat = locations[1].position.lat;
            this.finish.lng = locations[1].position.lng;
        }
        this.initMap();
    }

    /**
     * This function will be called if a communication error occurs during the JSON-P request
     * @param  {Object} error  The error message received.
     */
    public onError(error) {
        console.log('Can\'t reach the remote server');
    }

    public ngOnInit() {
        this.platform = new H.service.Platform({
            apikey: this.ConfigData.apikey,
            useHTTPS: true
        });
        this.directions = [];
        this.router = this.platform.getRoutingService(null, 8);
    }

    ngAfterViewInit() {
        // Existing implementations
        if(this.start && this.finish){
            this.initMap(true);
            return
        }
        /**
         * 1. Both needs call geocode and get lat & lng
         * 2. Start have query(needs call geocode) and Finish have location(lat & lng)
         * 3. Start have lat & lng and finish query (needs call geocode)
         * 4. Both have lat & lang (No need of geocode call)
         * */
        let start = this.mapOptions.start;
        let finish = this.mapOptions.finish;
        let arr = [];
        if ((!start.query && (!start.lat || !start.lng)) &&
            (!finish.query && (!finish.lat && !finish.lng))) {
                // this.initMap();
                return;
        }
        if(!start.query && !finish.query){
            this.start = {
                lat: parseFloat(this.mapOptions.start.lat),
                lng: parseFloat(this.mapOptions.start.lng)
            }
            this.finish = {
                lat: parseFloat(this.mapOptions.finish.lat),
                lng: parseFloat(this.mapOptions.finish.lng)
            }
            this.initMap(true);
        }else {
            if(start.query){
                arr.push( this.geocode(this.platform, this.mapOptions.start.query));
            }
            if(finish.query){
                arr.push(this.geocode(this.platform, this.mapOptions.finish.query))
            }
            forkJoin(arr).subscribe((results: any)=>{
                if(start.query && finish.query){
                    this.start = results[0].position;
                    this.finish = results[1].position;
                }else if(start.query && !finish.query){
                    this.start = results[0].position;
                    this.finish = {
                        lat: parseFloat(this.mapOptions.finish.lat),
                        lng: parseFloat(this.mapOptions.finish.lng)
                    }
                    // this.finish.lat = this.mapOptions.finish.lat;
                    // this.finish.lng = this.mapOptions.finish.lng;
                }else if(!start.query && finish.query){
                    this.start = {
                        lat: parseFloat(this.mapOptions.start.lat),
                        lng: parseFloat(this.mapOptions.start.lng)
                    }
                    this.finish = results[0].position;
                }
                this.initMap(true);
            },(err)=>{
                this.isMapAvailabel = false;
                this.initMap(false)
            });
        }
    }

    public hereMapAPiError(err){
        console.log('api error', err);
    }

    public initMap(isRouteNeeded = true){
        const defaultLayers = this.platform.createDefaultLayers();
        // this.geocode(this.platform)
        this.map = new H.Map(
            this.mapElement.nativeElement,
            defaultLayers.vector.normal.map,
            {
                zoom: 4,
                pixelRatio: window.devicePixelRatio || 1,
                // 39.651184, -102.315836
                center: this.defaultUSALatAndLng,
                padding: {top: 35, left: 25, bottom: 35, right: 25}
            }
        );

        window.addEventListener('resize', this.resize);

        // MapEvents enables the event system
        // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
        let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
        behavior.disable(H.mapevents.Behavior.WHEELZOOM);

        // Create the default UI components
        this.ui = H.ui.UI.createDefault(this.map, defaultLayers);
        this.mapElement.nativeElement.firstChild.style.borderBottomLeftRadius ='15px';
        this.mapElement.nativeElement.firstChild.style.borderBottomRightRadius ='15px';

        if(isRouteNeeded){
            this.route(this.start, this.finish);
            this.map.setCenter({ lat: (this.start.lat + this.finish.lat) / 2, lng: (this.start.lng + this.finish.lng) / 2 });
        }
    }

    public ngOnChanges(changes: SimpleChanges) {
        if ((changes['start'] && !changes['start'].isFirstChange()) || (changes['finish'] && !changes['finish'].isFirstChange())) {
            this.route(this.start, this.finish);
        }
        // if((changes['startLoc'] && !changes['startLoc'].isFirstChange()) || (changes['endLoc'] && !changes['endLoc'].isFirstChange())){
        //     this.geocode(this.platform)
        // }
    }

    public ngOnDestroy() {
        window.removeEventListener('resize', this.resize);
    }

    public route(start: any, finish: any) {
        var routingParameters = {
            'origin': this.start.lat + ',' + this.start.lng,
            'destination': this.finish.lat + ',' + this.finish.lng,
            'routingMode': 'fast',
            'transportMode': 'car',
            'return': 'polyline'
          };
        this.map.removeObjects(this.map.getObjects());

        this.router.calculateRoute(routingParameters, result => {
            if(result.routes.length){
                const lineStrings = [];
                result.routes[0].sections.forEach((section) => {
                    // Create a linestring to use as a point source for the route line
                    lineStrings.push(H.geo.LineString.fromFlexiblePolyline(section.polyline));
                });
                 // Create an instance of H.geo.MultiLineString
                const multiLineString = new H.geo.MultiLineString(lineStrings);

                // Create a polyline to display the route:
                const routeLine = new H.map.Polyline(multiLineString, {
                    style: {
                        strokeColor: 'rgb(255,204,0)',
                        lineWidth: 5
                    }
                });

                // Create a marker for the start point:
                const startMarker = new H.map.Marker({
                    lat: this.start.lat,
                    lng: this.start.lng
                });

                // Create a marker for the end point:
                const endMarker = new H.map.Marker({
                    lat: this.finish.lat,
                    lng: this.finish.lng
                });
                const group = new H.map.Group();
                if (this.startLabelData) {
                const startLabel = new H.map.DomMarker(
                    { lat: this.start.lat, lng: this.start.lng },
                    {icon: new H.map.DomIcon(`
                    <div style="background:#fff;padding:8px 12px;border-radius:6px;
                                box-shadow:0 2px 6px rgba(0,0,0,0.25);font-size:13px;line-height:18px;">
                        <b>Consignee</b><br>
                        ${this.startLabelData}
                    </div>
                    `)
                    }
                );
                group.addObjects([startLabel]);
                }
                if (this.endLabelData) {
                const endLabel = new H.map.DomMarker(
                    { lat: this.finish.lat, lng: this.finish.lng },
                    {
                        icon: new H.map.DomIcon(`
                            <div style="position:relative;background:#fff;padding:8px 12px 8px 16px;border-radius:6px;box-shadow:0 2px 6px rgba(0,0,0,0.25);font-size:13px;line-height:18px;"><div style="position:absolute;left:-8px;top:16px;width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-right:8px solid white;"></div><b>Consignor</b><br>${this.endLabelData}</div>`,
                            {anchor: { x: 0, y: 20 }
                        })
                    }

                );
                group.addObjects([endLabel]);
                }

                 // Create a H.map.Group to hold all the map objects and enable us to obtain 
                // the bounding box that contains all its objects within
                
                group.addObjects([routeLine, startMarker, endMarker]);             
                // 🔥 CURRENT TRUCK LOCATION MARKER
                if (this.currentTruckLocation) {

                    const truckIcon = new H.map.DomIcon(`
                        <div style="background:#FFC107;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.4);"><svg width="22" height="22" viewBox="0 0 24 24" fill="black"><path d="M3 13h11v-2H3v2zm0 3h11v-2H3v2zm13-3h5l-1.5-4.5H16V5H2v13h2a2 2 0 004 0h6a2 2 0 004 0h2v-3h-2zM7 19a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2z"/></svg></div>
`);

                    const truckMarker = new H.map.DomMarker(
                        {
                            lat: this.currentTruckLocation.lat,
                            lng: this.currentTruckLocation.lng
                        },
                        {
                            icon: truckIcon
                        }
                    );

                    const truckLabel = new H.map.DomMarker(
                        { lat: this.currentTruckLocation.lat, lng: this.currentTruckLocation.lng },
                        { icon: new H.map.DomIcon(`
                            <div style="position:relative;background:#fff;padding:8px 12px 8px 16px;border-radius:6px;box-shadow:0 2px 6px rgba(0,0,0,0.25);font-size:13px;line-height:18px;margin-left:30px;margin-top:25px;"><div style="position:absolute;left:-8px;top:16px;width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-right:8px solid white;"></div>
                            <b>Lat:</b> ${this.currentTruckLocation.lat}<br>
                            <b>Long:</b> ${this.currentTruckLocation.lng}<br>
                            <b>Updated on:</b> ${this.currentTruckLocation.updatedAt}
                            </div>`, { anchor: { x: 0, y: 45 }})
                        }
                    );
                  
                    group.addObject(truckLabel);
                    group.addObject(truckMarker);
                }

                // Add the group to the map
                this.map.addObject(group);

                // Set the map viewport to make the entire route visible:
                this.map.getViewModel().setLookAtData({
                    bounds: group.getBoundingBox()
                });
                
            }
        }, error => {
            this.isMapAvailabel  = false;
            this.moveMapToUSA();
            console.error(error);
        });
    }

    private resize = () => {
        this.map.getViewPort().resize();
        if (this.routeLine) {
            this.map.getViewModel().setLookAtData({
                // maxZoom:maxZoom,
                // zoom:4,
                bounds: this.routeLine.getBoundingBox(),
                tilt: 10
            });
        }
    }

    moveMapToUSA(){
        this.map.setCenter(this.defaultUSALatAndLng);
        this.map.setZoom(4);
    }

}
